// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"518de9ee","597":"070badff"}[chunkId] + ".chunk.css";
};